import React from "react";
import { Controller } from "react-hook-form";
import {
  Checkbox,
  FormControl,
  FormControlLabel,
  FormHelperText,
} from "@mui/material";

const CheckboxController = ({
  name,
  label,
  required,
  control,
  errors,
  disabled = false,
}) => {
  return (
    <FormControl error={!!errors[name]} required={required}>
      <Controller
        name={name}
        control={control}
        render={({ field }) => (
          <FormControlLabel
            control={
              <Checkbox
                {...field}
                checked={!!field.value}
                onChange={(e) => field.onChange(e.target.checked)}
                color="primary"
                disabled={disabled}
              />
            }
            label={label}
          />
        )}
      />
      {errors[name] && <FormHelperText>{errors[name].message}</FormHelperText>}
    </FormControl>
  );
};

export default CheckboxController;
